import Footer from "@scenes/pdp/utils/Footer";
import { DiamondDetail } from "@src/types/DiamondDetail";

type FooterModelProps = {
  isOpen?: boolean;
  onClose?: () => void;
  OtherDetail?: DiamondDetail[];
  currentIndex?: number;
  setCurrentIndex?: any;
  ceterIconTheme?: string;
  centerString?: string;
  preText?: string;
  postText?: string;
};

const FooterModel = ({
  OtherDetail,
  currentIndex = 0,
  setCurrentIndex,
  ceterIconTheme,
  centerString = "/",
  preText = "",
  postText = "",
}: FooterModelProps) => {
  const leftClickEvent = () => {
    if (currentIndex !== 0) {
      setCurrentIndex(currentIndex - 1);
    } else {
      setCurrentIndex((OtherDetail?.length || 1) - 1);
    }
  };

  const rightClickEvent = () => {
    if (OtherDetail && currentIndex < OtherDetail?.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setCurrentIndex(0);
    }
  };

  if (OtherDetail?.length === 0) return null;

  return (
    <Footer
      enableArrowsOnEnd={false}
      hasArrow={true}
      leftClickEvent={leftClickEvent}
      rightClickEvent={rightClickEvent}
      total={OtherDetail?.length as number}
      centerString={centerString}
      currentIndex={currentIndex}
      ceterIconTheme={ceterIconTheme}
      preText={preText}
      postText={postText}
    />
  );
};

export default FooterModel;
